// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"9786ef77","498":"1864095f","703":"3c176d1e"}[chunkId] + ".chunk.js";
};